/* Product gallery, delivery display, size guide and custom-price calculator.
   Custom prices use the ERP Shopify selling rate; only the final USD price is displayed. */
(function () {
  // —— GALLERY ——
  // One index owns the state. Arrows, keyboard, swipe and thumbnail clicks all move that
  // index; images and videos are already rendered by Liquid so changing media never rewrites URLs.
  var gal = document.querySelector('[data-gal]');
  if (gal) {
    var slides = [].slice.call(gal.querySelectorAll('[data-media-slide]'));
    var thumbs = [].slice.call(document.querySelectorAll('[data-media-thumb]'));
    var idx = 0;
    var countEl = gal.querySelector('[data-gal-count]');

    function show(i, focusThumb) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.hidden = n !== idx;
        if (n !== idx) [].slice.call(slide.querySelectorAll('video')).forEach(function (video) { video.pause(); });
      });
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('on', n === idx);
        t.setAttribute('aria-pressed', n === idx ? 'true' : 'false');
      });
      if (focusThumb && thumbs[idx] && thumbs[idx].scrollIntoView) {
        thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    gal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-gal-prev]')) { ev.preventDefault(); show(idx - 1, true); }
      if (ev.target.closest('[data-gal-next]')) { ev.preventDefault(); show(idx + 1, true); }
    });

    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-media-thumb]');
      if (!t) return;
      var n = thumbs.indexOf(t);
      if (n > -1) show(n, false);
    });

    // Arrow keys, but never while the shopper is typing in a field.
    document.addEventListener('keydown', function (ev) {
      if (slides.length < 2) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      if (ev.key === 'ArrowLeft') show(idx - 1, true);
      if (ev.key === 'ArrowRight') show(idx + 1, true);
    });

    // Swipe. Horizontal intent only, so a vertical page scroll is never hijacked.
    var sx = 0, sy = 0, tracking = false;
    gal.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    show(0, false);
  }

  // —— sticky mobile add-to-cart mirrors the real form ——
  var matc = document.querySelector('[data-matc]');
  if (matc) {
    matc.addEventListener('click', function () {
      var f = document.querySelector('form[data-product-form]');
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  }
  var sel = document.querySelector('[data-variant-select]');
  var mp = document.querySelector('[data-matc-price]');
  if (sel && mp) {
    sel.addEventListener('change', function () {
      setTimeout(function () {
        var main = document.querySelector('[data-price]');
        if (main) mp.textContent = main.textContent;
      }, 0);
    });
  }

  // —— delivery estimate: stock ships 3–6 days, made-to-order weaves 3–4 weeks ——
  // Under MTO_ONLY the stock number is ignored, so the date range can never contradict the
  // availability line above it (operator 2026-09-08).
  var etaEl = document.querySelector('[data-eta]');
  if (etaEl) {
    var etaMode = sel ? (sel.getAttribute('data-mode') || 'STOCK_AND_MTO') : 'STOCK_AND_MTO';
    var fmtD = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };
    var setEta = function (instock) {
      var a = new Date(), b = new Date();
      if (instock) { a.setDate(a.getDate() + 3); b.setDate(b.getDate() + 6); }
      else { a.setDate(a.getDate() + 21); b.setDate(b.getDate() + 28); }
      etaEl.hidden = false;
      etaEl.textContent = 'Order today — estimated arrival ' + fmtD(a) + ' – ' + fmtD(b);
    };
    setEta(etaMode !== 'MTO_ONLY' && etaEl.getAttribute('data-instock') === '1');
    if (sel) {
      var vdata = {};
      try { vdata = JSON.parse(sel.getAttribute('data-variants')); } catch (e) {}
      sel.addEventListener('change', function () {
        var vv = vdata[sel.value];
        if (vv) setEta(etaMode !== 'MTO_ONLY' && vv.available && vv.qty > 0);
      });
    }
  }

  // —— size-guide dialog ——
  var sg = document.querySelector('[data-sizeguide]');
  if (sg) {
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-open-sizeguide]') && sg.showModal) sg.showModal();
      if (ev.target.closest('[data-close-sizeguide]')) sg.close();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.closest && ev.target.closest('[data-open-sizeguide]') && sg.showModal) sg.showModal();
    });
    sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });
  }

  var calc = document.querySelector('[data-calc]');
  if (!calc || !window.IndiaLivingSizes) return;
  var engine = window.IndiaLivingSizes;
  var variants = JSON.parse(calc.querySelector('[data-calc-variants]').textContent);
  var text = JSON.parse(calc.querySelector('[data-calc-text]').textContent);
  var rate = Number(calc.getAttribute('data-rate'));

  var unitSel = calc.querySelector('[data-calc-unit]');
  var shapeSel = calc.querySelector('[data-calc-shape]');
  var width = calc.querySelector('[data-calc-w]'), widthIn = calc.querySelector('[data-calc-w-in]');
  var length = calc.querySelector('[data-calc-l]'), lengthIn = calc.querySelector('[data-calc-l-in]');
  var lengthWrap = calc.querySelector('[data-calc-len]');
  var price = calc.querySelector('[data-calc-price]'), note = calc.querySelector('[data-calc-note]');
  var unit = 'ft';
  var groupNames = { rect:'Rectangular', square:'Square', round:'Round', runner:'Runner' };
  var offered = variants.map(function(v){return engine.parse(v.title).group;});
  // Only offer shapes actually sold for this product. Never assume a flatweave can be cut round.
  [].slice.call(shapeSel.options).forEach(function(o){ if(offered.indexOf(groupNames[o.value])<0) o.remove(); });
  function feet(main, inches) {
    if (main.value === '') return null;
    var n=Number(main.value), i=Number(inches.value || 0);
    if(!Number.isFinite(n) || !Number.isFinite(i) || n<0 || i<0 || i>=12) return null;
    var value=unit === 'cm' ? n/30.48 : n+i/12;
    return value>=1 ? value : null;
  }
  function compute() {
    var equal=shapeSel.value === 'round' || shapeSel.value === 'square';
    lengthWrap.hidden=equal;
    var w=feet(width,widthIn), l=equal ? w : feet(length,lengthIn);
    price.textContent=''; note.textContent='';
    if(w===null || l===null || !shapeSel.value){ note.textContent=text.invalid; return; }
    var amount=engine.customPrice(rate,groupNames[shapeSel.value],w,l);
    if(amount===null || !Number.isFinite(amount) || amount<=0){ note.textContent=text.unpriced; return; }
    price.textContent=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:'USD'}).format(amount/100);
  }
  unitSel.addEventListener('change',function(){
    var next=unitSel.value;
    if(next===unit) return;
    [[width,widthIn],[length,lengthIn]].forEach(function(pair,index){
      var value=feet(pair[0],pair[1]);
      if(value!==null){
        if(next==='cm') pair[0].value=(value*30.48).toFixed(2);
        else { var inches=Math.round(value*12); pair[0].value=Math.floor(inches/12); pair[1].value=inches%12; }
      }
      pair[0].step=next==='cm'?'0.01':'1';

      pair[1].parentElement.style.display=next==='cm'?'none':'';
      pair[0].setAttribute('aria-label',(index===0?'Width':'Length')+(next==='cm'?', centimetres':', whole feet'));
      var suffix=calc.querySelector(index===0?'[data-calc-w-suffix]':'[data-calc-l-suffix]'); suffix.textContent=next==='cm'?'cm':'ft';
    });
    unit=next; compute();
  });
  [width,widthIn,length,lengthIn,shapeSel].forEach(function(el){el.addEventListener('input',compute);});
  compute();
})();
